<template>
  <div class="muit-action-container">
    <!-- 顶部导航栏 -->
    <div class="nav-bar">
      <i class="el-icon-arrow-left back-icon" @click="goBack()"></i>
      <span class="title">多元智能测试</span>
      <div class="capsule"></div>
    </div>

    <!-- 头部信息区 -->
    <div class="hero-section">
      <h1 class="main-title">加德纳多元智能测评</h1>

      <div class="badge-wrapper">
        <span class="badge">共40题</span>
      </div>

      <p class="subtitle">
        请按照第一反应作答，不要过度思考<br />
        测试结果仅供参考，不作为决策唯一依据
      </p>

      <button class="start-btn" @click="handleStart">
        开始测评 <i class="el-icon-right"></i>
      </button>
    </div>

    <!-- 白色内容卡片 -->
    <div class="content-card">
      <h2 class="section-title">多元智能评测</h2>
      <ul class="feature-list">
        <li class="feature-item">• 识别个体在不同智能领域的优势与不足。</li>
        <li class="feature-item">• 为职业选择、教育发展和团队配置提供科学参考。</li>
        <li class="feature-item">• 促进个体全面发展、激发潜能。</li>
      </ul>

      <h2 class="section-title">测评意义</h2>
      <p class="text-paragraph">
        多元智能测评(MultipleIntelligencesAssessment)基于美国心理学家霍华德加德纳(HowardGardner)于1983年提出的多元智能理论(TheoryofMultipleIntelligences)。该理论认为，智能并非单一维度，而是由多种相对独立的智能类型组成，包括语言智能、逻辑数学智能、空间智能、音乐智能、身体动觉智能、人际智能、内省智能、自然智能等。多元智能测评通过科学评估个体在不同智能领域的优势与不足，为个人发展和组织管理提供重要参考。以下是多元智能测评的具体意义分析：
      </p>

      <h3 class="sub-title">一、对个人的意义</h3>
      <p class="text-paragraph">
        <strong>1.发现多元优势，避免单一评价</strong><br />
        多元智能测评帮助个人识别自己在不同智能领域的优势。
      </p>
      <p class="text-paragraph">
        <strong>2.优化职业选择，提升职业满意度</strong><br />
        通过多元智能测评，个人可以更精准地选择与自己智能优势匹配的职业。
      </p>
      <p class="text-paragraph">
        <strong>3.促进全面发展、弥补短板</strong><br />
        多元智能测评不仅帮助个人发现优势，还能识别不足，从而制定针对性的学习和发展计划。
      </p>
      <p class="text-paragraph">
        <strong>4.增强自信心、激发潜能</strong><br />
        通过多元智能测评，个人可以更清晰地认识到自己在多个领域的潜能，从而增强自信心。
      </p>

      <h3 class="sub-title">二、对组织的意义</h3>
      <p class="text-paragraph">
        <strong>1.优化人才选拔、提高招聘精准度</strong><br />
        多元智能测评可以帮助组织更全面地评估候选人的能力。
      </p>
      <p class="text-paragraph">
        <strong>2.合理配置团队、提升团队效能</strong><br />
        通过多元智能测评，组织可以了解团队成员的智能分布，从而优化团队配置。
      </p>
      <p class="text-paragraph">
        <strong>3.制定个性化培养方案、提升员工绩效</strong><br />
        多元智能测评可以帮助组织为员工制定个性化的发展计划。
      </p>
      <p class="text-paragraph">
        <strong>4.增强组织创新力、提升竞争力</strong><br />
        多元智能测评有助于组织发现和培养具有特殊智能优势的人才，从而增强组织的创新力。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "MuitAction",
  methods: {
    handleStart() {
      this.$router.push("/muit-qa");
    },
    goBack() {
      this.$router.push("/muit-home");
    },
  },
};
</script>

<style scoped>
.muit-action-container {
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  background: linear-gradient(180deg, #fbfff9 0%, #ecffe5 24%, #80d878 100%);
  font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
  position: relative;
  overflow: hidden;
  padding-bottom: 20px;
}

.muit-action-container::before {
  content: "";
  position: absolute;
  left: -8%;
  top: 68px;
  width: 116%;
  height: 200px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.22) 0%, transparent 42%),
    linear-gradient(45deg, rgba(255, 255, 255, 0.18) 0%, transparent 48%);
  pointer-events: none;
}

.nav-bar {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
}

.back-icon {
  font-size: 22px;
  color: #1d2b1c;
  cursor: pointer;
}

.title {
  font-size: 18px;
  font-weight: 700;
  color: #1d2b1c;
}


.hero-section {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 18px 22px 26px;
}

.main-title {
  margin: 0 0 12px;
  font-size: 18px;
  line-height: 1.3;
  font-weight: 800;
  color: #73c257;
}

.badge-wrapper {
  margin-bottom: 14px;
}

.badge {
  display: inline-block;
  padding: 6px 16px;
  background: #fff;
  color: #233322;
  font-size: 16px;
  line-height: 1.1;
  font-weight: 800;
}

.subtitle {
  margin: 0 0 20px;
  color: #44b24f;
  font-size: 14px;
  line-height: 1.6;
  font-weight: 600;
}

.start-btn {
  width: 100%;
  height: 52px;
  border: none;
  border-radius: 26px;
  background: linear-gradient(90deg, #98dd5d 0%, #59cb79 100%);
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.start-btn i {
  margin-left: 8px;
  font-size: 16px;
}

.content-card {
  position: relative;
  z-index: 2;
  background: #fff;
  border-radius: 18px;
  margin: 0 14px;
  padding: 18px 16px 28px;
  box-shadow: 0 6px 18px rgba(71, 151, 84, 0.18);
}

.section-title {
  margin: 0 0 10px;
  text-align: center;
  font-size: 16px;
  color: #25304a;
  font-weight: 700;
}

.feature-list {
  list-style: none;
  margin: 0 0 14px;
  padding: 0;
}

.feature-item {
  font-size: 13px;
  color: #818894;
  line-height: 1.75;
}

.sub-title {
  margin: 14px 0 8px;
  font-size: 15px;
  color: #25304a;
  font-weight: 700;
}

.text-paragraph {
  margin: 0 0 10px;
  font-size: 13px;
  color: #666;
  line-height: 1.68;
  text-align: justify;
}

.text-paragraph strong {
  color: #3f454f;
}
</style>
